export default "__VITE_ASSET__m7sxZl1A__"